export default {
  state: {
    groupsList: {
      total: 0,
      groups: [],
    },
    groupInfo: {
      name: '',
    },
    groupUsers: {
      total: 0,
      users: [],
    },
  },
  mutations: {
    setGroupsList: (state, { list }) => {
      state.groupsList.total = list.total;
      state.groupsList.groups = list.data;
    },
    setGroupUsersList: (state, { list }) => {
      state.groupUsers.total = list.total;
      state.groupUsers.users = list.data;
    },
    setGroupInfo: (state, { list }) => {
      state.groupInfo = list;
    },
  },
  actions: {},
}
